import axios from "axios";
import Vue from "vue";
import * as Utils from "../utils";
import Sjcl from "../filters/encrypt-sjcl.js";

class AuthService extends Vue {
  constructor() {
    super();
    if (!!localStorage.getItem("currentUser")) {
      this._currentUser = JSON.parse(localStorage.getItem("currentUser"));
      this._parentUser = JSON.parse(localStorage.getItem("parentUser"));
    }
  }

  get currentUser() {
    return this._currentUser;
  }

  set currentUser(user) {
    if (user) {
      localStorage.setItem("currentUser", JSON.stringify(user));
    } else {
      localStorage.removeItem("currentUser");
    }

    this._currentUser = user;
    this.$emit("userChanged", user);
  }

  get parentUser() {
    return this._parentUser;
  }

  set parentUser(user) {
    if (user) {
      localStorage.setItem("parentUser", JSON.stringify(user));
    } else {
      localStorage.removeItem("parentUser");
    }

    this._parentUser = user;
    this.$emit("parentUserChanged", user);
  }

  checkUserLoggedGuard(route_to, route_from, next) {
    if (route_to.name == "login") {
      if (!!this.currentUser) next({ name: "plans" });

      next();
      return;
    }
    if (route_to.name == "2fa-interno") {
      next();
      return;
    }
    if (!this.currentUser) {
      next({ name: "login" });
    } else {
      next();
    }
  }

  updateLocalStorage() {
    localStorage.setItem("currentUser", JSON.stringify(this._currentUser));
  }

  /**
   * Faz o login e retorna os dados do usuário autenticado.
   *
   * @param username: o nome do usuário (usualmente CPF/CNPJ)
   * @param password: a senha
   * @param email: o email do usuario CNPJ
   * @returns Promise<Object> dados do usuário
   */
  // .post('/v2/auth/login', {login: {taxIdNumber: username,
  // .post('/v1/login2', {login: {taxIdNumber: username,
  login(username, password, email) {
    return axios
      .post("/v2/auth/login", {
        login: {
          taxIdNumber: username,
          password: password,
          email: email,
          _interface: window.document.webview ? "MOBILE" : "WEBSITE",
        },
        versionMobile: window.document.webview ? 10 : undefined,
      })
      .then((r) => {
        let redirect2FA = r.data.redirect_2fa;
        this.saveLoginTFA(redirect2FA);
        if (redirect2FA === "Y") {
          return r.data;
        } else {
          return axios
            .get("/v2/getUserAndAddressByMoveMaisId/" + r.data.token.movemaisId)
            .then((res) => {
              if (res.data.user.salesReferenceOther !== "REPOM") {
                let user = res.data.user;
                user.ssa = res.data.ssa;
                user.sessionId = res.data.sessionId;
                user.address = res.data.address;
                this.currentUser = res.data.user;
                this.parentUser = res.data.user;
                this.$emit("loginSucessful", this.currentUser);
                this.$emit("userChanged", this.currentUser);
              } else {
                return res.data.user;
              }
              return this.currentUser;
            });
        }
      });
  }

  checkUserPassword(taxIdNumber, password) {
    return axios
      .post("/v2/checkUserPassword", {
        taxIdNumber: taxIdNumber,
        password: password,
      })
      .then((r) => {
        return r.data;
      });
  }

  checkCpfValidationPermission() {
    const now = Date.now();
    if (
      this._internalToken &&
      this._internalTokenExpiry &&
      now < this._internalTokenExpiry
    ) {
      return Promise.resolve({ token: this._internalToken });
    }

    return axios.get("/v2/internal/token", {}).then((r) => {
      if (r.data && r.data.token) {
        this._internalToken = r.data.token;
        this._internalTokenExpiry = Date.now() + 4 * 60 * 1000;
      }
      return r.data;
    });
  }

  checkUserPasswordTransfer(taxIdNumber, password) {
    return axios
      .post("/v2/checkUserPasswordTransfer", {
        taxIdNumber: taxIdNumber,
        password: password,
      })
      .then((r) => {
        return r.data;
      });
  }

  /**
   * Faz logout.
   *
   * Somente na interface. TODO: eliminar o token no servidor.
   *
   * @returns Promise<Object>
   */
  logout() {
    this.currentUser = undefined;
    this.parentUser = undefined;
    localStorage.removeItem("contracts_current_user");
    localStorage.removeItem("currentUser");
    return Promise.resolve(null);
  }

  /**
   * Inicia requisição de recuperação de senha.
   *
   * @return Promise resolve se der certo ou rejeita com os dados da requisição
   */
  requestPasswordReset(username) {
    return axios
      .post("/v1/requestPasswordReset", {
        taxIdNumber: username,
        _interface: "WEBSITE",
      })
      .then((res) => {
        return Promise.resolve(true);
      });
  }

  newRequestPasswordReset(userName, movemaisId) {
    return axios
      .post("/v2/auth/genHashM", {
        taxIdNumber: userName,
        movemaisId: movemaisId,
      })
      .then((res) => {
        return Promise.resolve(true);
      });
  }

  /**
   * Valida o token por moveMaisId e código.
   *
   * @param moveMaisId ID do Move Mais do usuário
   * @param codigo Código de 6 dígitos
   * @return Promise resolve se der certo ou rejeita com os dados da requisição
   */
  validarTokenPorMoveMaisId(moveMaisId, codigo) {
    return axios
      .post(`/v2/auth/validarTokenPorMoveMaisId/${moveMaisId}/${codigo}`)
      .then((res) => {
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  /**
   * Altera a senha do usuário usando um token de definição de senha.
   *
   * @param token
   * @param password
   * @return Promise resolve se der certo ou rejeita com os dados da requisição
   */
  resetPassword(newPassword, movemaisId) {
    return axios
      .post("/v2/auth/resetPassword", {
        newPassword: newPassword,
        moveMaisId: Number(movemaisId),
        _interface: "WEBSITE",
      })
      .then((res) => {
        return Promise.resolve(true);
      });
  }
  resetPasswordV1(token, password) {
    return axios
      .post("/v1/resetPassword", {
        newPassword: password,
        passwordToken: token,
        _interface: "WEBSITE",
      })
      .then((res) => {
        return Promise.resolve(true);
      });
  }

  /**
   * Altera a senha do usuário usando a senha atual,  a nova senha e confirma nova senha.
   *
   * @param currentPassword
   * @param newPassword
   * @return Promise resolve se der certo ou rejeita com os dados da requisição
   */
  changePassword(currentPassword, newPassword) {
    return axios
      .post("/v2/auth/changePassword", {
        currentPassword: currentPassword,
        newPassword: newPassword,
        taxIdNumber: this._currentUser.taxIdNumber,
      })
      .then((res) => {
        return Promise.resolve(true);
      });
  }

  changeCurrentUser(moveMaisId) {
    return axios
      .get(`/v2/getUserAndAddressByMoveMaisId/${moveMaisId}`)
      .then((res) => {
        const userAndAddress = Object.assign(res.data.user, {
          address: res.data.address,
        });
        this.currentUser = userAndAddress;
      });
  }

  /**
   * Faz o login do atendente no site retorna os dados do usuário autenticado.
   *
   * @param taxIdNumber do cliente
   * @param sessionId do atendente
   * @returns Promise<Object> dados do cliente
   */
  //  loginAtendente(sessionId, moveMaisId) {
  //      .post('/v1/loginAtendente', {taxIdNumber: '000', sessionId: sessionId})
  loginAtendente(passwordSiva, accessToken) {
    return (
      axios
        // , PFL: userBackofficeId
        .post(`/v2/lgnAtn/${passwordSiva}`, { GZK: accessToken })
        .then((r) => {
          return axios.get(`/v2/getUserAndAddressByMoveMaisId/${r.data.id}`);
        })
        .then((res) => {
          let user = res.data.user;
          user.address = res.data.address;
          this.currentUser = res.data.user;
          this.parentUser = res.data.user;
          return this.currentUser;
        })
    );
  }

  loginSSA(taxIdNumber, sessionId) {
    return axios
      .post("/v1/loginSSA", { taxIdNumber: taxIdNumber, sessionId: sessionId })
      .then((r) => {
        return axios.get(`/v2/getUserAndAddressByTaxIdNumber/${taxIdNumber}`);
      })
      .then((res) => {
        let user = res.data.user;
        user.address = res.data.address;
        this.currentUser = res.data.user;
        this.parentUser = res.data.user;
        return this.currentUser;
      });
  }

  saveTaxId(taxId, pass) {
    let password = Sjcl.encrypt("password", pass);
    localStorage.setItem("taxId", taxId);
    localStorage.setItem("password", password);
  }

  saveTaxIdNumber(taxIdNumber) {
    localStorage.setItem("taxIdNumber", taxIdNumber);
  }

  getTaxIdNumber() {
    return localStorage.getItem("taxIdNumber");
  }

  getTaxId(taxId) {
    return localStorage.getItem("taxId");
  }

  getTaxIdFromSession() {
    var cookie = Utils.getCookie("PLAY_SESSION");
    return cookie.substr(cookie.indexOf("taxId"), 16).split("=")[1];
  }

  getPass(pass) {
    return Sjcl.decrypt("password", localStorage.getItem("password"));
  }

  deleteTaxId() {
    localStorage.removeItem("taxId");
  }

  saveHash(hash) {
    localStorage.setItem("hash", hash);
  }

  getHash() {
    return localStorage.getItem("hash");
  }

  validUserResetPassword(taxIdNumber, phone, email) {
    return axios
      .post("/v2/auth/validUserResetPassword", {
        taxIdNumber: taxIdNumber,
        phone: phone,
        email: email,
      })
      .then((res) => {
        return res.data;
      });
  }

  twoFactorAuthentication(taxIdNumber, token, origin) {
    return axios
      .post("/v2/twoFactorAuthentication/checkOTP", {
        taxIdNumber: taxIdNumber,
        token: token,
        origin: origin,
        _interface: "WEBSITE",
      })
      .then((res) => {
        return res.data;
      });
  }

  tokenGenerateResend(taxIdNumber, origin, channel) {
    return axios
      .post("/v2/twoFactorAuthentication/tokenGenerateResend", {
        taxIdNumber: taxIdNumber,
        origin,
        channel,
      })
      .then((res) => {
        return res.data;
      });
  }

  twoFactorAuthenticationNew(taxIdNumber, token, origin, to) {
    return axios
      .post("/v2/twoFactorAuthenticationNew/checkOTP", {
        taxIdNumber,
        token,
        origin,
        _interface: "WEBSITE",
        to,
      })
      .then((res) => {
        return res.data;
      });
  }

  tokenGenerateResendNew(taxIdNumber, origin, to) {
    return axios
      .post("/v2/twoFactorAuthenticationNew/tokenGenerateResend", {
        taxIdNumber,
        origin,
        to,
      })
      .then((res) => {
        return res.data;
      });
  }
  retrieveEmail(taxIdNumber, phone) {
    return axios
      .post("/v2/auth/retrieveEmail", {
        taxIdNumber: taxIdNumber,
        phone: phone,
      })
      .then((res) => {
        return res.data;
      });
  }

  saveToken(token) {
    localStorage.setItem("token", token);
  }

  getToken() {
    return localStorage.getItem("token");
  }

  saveMoveMaisId(movemaisId) {
    localStorage.setItem("movemaisId", movemaisId);
  }

  getMoveMaisId() {
    return localStorage.getItem("movemaisId");
  }

  requestChangePassword(taxIdNumber) {
    return axios
      .post("/v2/auth/requestChangePassword", { taxIdNumber: taxIdNumber })
      .then((res) => {
        return res.data;
      });
  }

  validToken(password, hashUrl) {
    return axios
      .post("/v2/auth/validToken", { token: hashUrl, password: password })
      .then((res) => {
        return res.data;
      });
  }

  sendTokenNewUserData(taxIdNumber, phone, email) {
    return axios
      .post("/v2/sendTokenNewUserData", {
        taxIdNumber: taxIdNumber,
        phone: phone,
        email: email,
      })
      .then((res) => {
        return res.data;
      });
  }

  /**
   * Envia código de verificação de email para o usuário.
   *
   * @param taxIdNumber CPF/CNPJ do usuário
   * @return Promise resolve se der certo ou rejeita com os dados da requisição
   */
  sendEmailValidationCode(taxIdNumber) {
    return axios
      .post("/v2/auth/sendEmailValidationCode", {
        taxIdNumber: taxIdNumber,
        _interface: "WEBSITE",
      })
      .then((res) => {
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  /**
   * Gera token e envia código por canal de notificação para o usuário.
   *
   * @param moveMaisId ID do Move Mais do usuário
   * @param channel Canal de notificação (WHATSAPP, SMS, EMAIL) - obrigatório
   * @return Promise resolve se der certo ou rejeita com os dados da requisição
   */
  generateTokenSite(moveMaisId, channel) {
    if (!channel) {
      return Promise.reject(new Error("Canal de notificação é obrigatório"));
    }

    // Converte o formato interno para o formato da API
    const channelMap = {
      WHATSAPP: "WHATSAPP",
      SMS: "SMS",
      EMAIL: "E-MAIL",
    };

    const apiChannel = channelMap[channel] || channel;

    return axios
      .post(`/v2/auth/generateTokenSite/${moveMaisId}/${apiChannel}`)
      .then((res) => {
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  /**
   * Valida o código de verificação de email enviado para o usuário.
   *
   * @param taxIdNumber CPF/CNPJ do usuário
   * @param code Código de 6 dígitos
   * @return Promise resolve se der certo ou rejeita com os dados da requisição
   */
  validateEmailCode(taxIdNumber, code) {
    return axios
      .post("/v2/auth/validateEmailCode", {
        taxIdNumber: taxIdNumber,
        code: code,
        _interface: "WEBSITE",
      })
      .then((res) => {
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  updateNewUserEmail(taxIdNumber, email) {
    return axios
      .post("/v2/updateNewUserEmail", {
        taxIdNumber: taxIdNumber,
        email: email,
      })
      .then((res) => {
        return res.data;
      });
  }

  updateNewUserPhone(taxIdNumber, newCellPhone) {
    return axios
      .post("/v2/updateNewUserPhone", {
        taxIdNumber: taxIdNumber,
        phone: newCellPhone,
      })
      .then((res) => {
        return res.data;
      });
  }

  currentUserData(taxIdNumber) {
    return axios
      .get(`/v2/getUserAndAddressByTaxIdNumber/${taxIdNumber}`)
      .then((res) => {
        return res.data;
      });
  }

  /**
   * Calcula HMAC-SHA256 para assinatura de requisições
   * @param {string} data - Dados para assinar
   * @param {string} secret - Chave secreta
   * @returns {string} Assinatura HMAC em hexadecimal
   */
  calculateHMAC(data, secret) {
    try {
      // Usa a mesma abordagem já utilizada no projeto (webpack permite require('crypto'))
      const crypto = require("crypto");
      return crypto.createHmac("sha256", secret).update(data).digest("hex");
    } catch (e) {
      console.error("Error calculating HMAC:", e);
      throw new Error(
        "Falha ao calcular assinatura HMAC. Certifique-se de que a biblioteca crypto está disponível.",
      );
    }
  }

  /**
   * Comparação timing-safe para evitar timing attacks
   * @param {string} a - Primeira string
   * @param {string} b - Segunda string
   * @returns {boolean} True se forem iguais
   */
  constantTimeEquals(a, b) {
    if (a.length !== b.length) {
      return false;
    }
    let result = 0;
    for (let i = 0; i < a.length; i++) {
      result |= a.charCodeAt(i) ^ b.charCodeAt(i);
    }
    return result === 0;
  }

  /**
   * Constrói headers de autenticação baseado nos parâmetros fornecidos
   * Suporta três métodos:
   * 1. API Key simples (apenas apiKey)
   * 2. Bearer Token (apenas bearerToken)
   * 3. API Key com assinatura HMAC (apiKey, timestamp, secret)
   *
   * @param {Object} authOptions - Opções de autenticação
   * @param {string} authOptions.apiKey - API Key para autenticação simples ou HMAC
   * @param {string} authOptions.bearerToken - Bearer Token para autenticação
   * @param {string} authOptions.timestamp - Timestamp para assinatura HMAC
   * @param {string} authOptions.secret - Secret para calcular assinatura HMAC
   * @param {string} requestPath - Caminho da requisição para assinatura HMAC
   * @param {string} requestBody - Body da requisição para assinatura HMAC
   * @returns {Object} Headers de autenticação
   */
  buildAuthHeaders(authOptions = {}, requestPath = "", requestBody = "") {
    const headers = {};

    // Método 1: Bearer Token
    if (authOptions.bearerToken) {
      headers["Authorization"] = `Bearer ${authOptions.bearerToken}`;
      return headers;
    }

    // Método 2: API Key com assinatura HMAC
    if (authOptions.apiKey && authOptions.timestamp && authOptions.secret) {
      const dataToSign =
        authOptions.apiKey + authOptions.timestamp + requestPath + requestBody;
      const signature = this.calculateHMAC(dataToSign, authOptions.secret);

      if (signature) {
        headers["X-API-Key"] = authOptions.apiKey;
        headers["X-Timestamp"] = authOptions.timestamp;
        headers["X-Signature"] = signature;
        return headers;
      }
    }

    // Método 3: API Key simples
    if (authOptions.apiKey) {
      headers["X-API-Key"] = authOptions.apiKey;
      return headers;
    }

    return headers;
  }

  /**
   * Gera um hash aleatório para uso na geração de JWT
   *
   * @returns {string} Hash aleatório de 40 caracteres
   */
  generateRandomHash() {
    const chars =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let hash = "";
    const timestamp = Date.now().toString(36);

    // Gera hash aleatório combinando timestamp e caracteres aleatórios
    for (let i = 0; i < 40; i++) {
      if (i < timestamp.length) {
        hash += timestamp[i];
      } else {
        hash += chars.charAt(Math.floor(Math.random() * chars.length));
      }
    }

    // Adiciona mais aleatoriedade
    hash += Math.random().toString(36).substring(2, 15);
    hash += Math.random().toString(36).substring(2, 15);

    return hash.substring(0, 40);
  }

  /**
   * Descriptografa o token JWT usando a chave fornecida
   *
   * @param {string} encryptedToken - Token criptografado
   * @param {string} key - Chave para descriptografia (padrão: chave do sistema)
   * @returns {string} Token descriptografado
   */
  decryptToken(encryptedToken, key = null) {
    if (!key) {
      // Chave padrão do sistema
      key = "fbf920c9-7847-43c6-ae66-ae3ede546c5b";
    }

    try {
      // Usa SJCL para descriptografar o token
      // O token deve estar no formato JSON do SJCL (com iv, salt, etc.)
      const decrypted = Sjcl.decrypt(key, encryptedToken);
      return decrypted;
    } catch (error) {
      console.error("Erro ao descriptografar token:", error);
      // Se falhar, tenta retornar o token original (pode não estar criptografado)
      return encryptedToken;
    }
  }

  /**
   * Gera JWT usando CPF/CNPJ
   *
   * @param {string} taxIdNumber - CPF/CNPJ do usuário
   * @param {string} hashAleatorio - Hash aleatório gerado pelo frontend (opcional, será gerado se não fornecido)
   * @returns {Promise<string>} Bearer Token (JWT) descriptografado
   */
  generateCpfJwt(taxIdNumber, hashAleatorio = null) {
    if (!hashAleatorio) {
      hashAleatorio = this.generateRandomHash();
    }

    // Envia o hash aleatório tanto no header quanto no payload
    const headers = {
      "X-Frontend-Hash": hashAleatorio,
      "Content-Type": "application/json",
    };

    return axios
      .post(
        "/v2/generateCpfJwt",
        {
          cpf: taxIdNumber,
          hashAleatorio: hashAleatorio,
        },
        { headers },
      )
      .then((res) => {
        if (res.data && res.data.status && res.data.status.code === 0) {
          if (res.data.token) {
            // Descriptografa o token antes de retornar
            const decryptedToken = this.decryptToken(res.data.token);
            return decryptedToken;
          }
          throw new Error("Token não encontrado na resposta");
        }
        const errorMessage =
          res.data && res.data.status && res.data.status.message
            ? res.data.status.message
            : "Erro ao gerar token";
        throw new Error(errorMessage);
      })
      .catch((error) => {
        console.error("Erro ao gerar JWT:", error);
        throw error;
      });
  }

  /**
   * Busca usuário e endereço por CPF/CNPJ sem sessão
   *
   * Fluxo:
   * 1. Gera hash aleatório
   * 2. Gera JWT usando CPF e hash aleatório (POST /v2/generateCpfJwt)
   * 3. Usa o JWT como Bearer Token no header Authorization
   * 4. Envia o hash aleatório no header X-Frontend-Hash
   * 5. Faz a requisição GET /v2/getUserAndAddressByTaxIdNumberNoSession/{cpf}
   *
   * @param {string} taxIdNumber - CPF/CNPJ do usuário
   * @param {Object} options - Opções (opcional)
   * @param {string} options.bearerToken - Bearer Token customizado (se fornecido, não gera novo JWT)
   * @param {string} options.hashAleatorio - Hash aleatório customizado (se fornecido, usa este hash)
   * @returns {Promise<Object>} Dados do usuário e endereço
   */
  async getUserAndAddressByTaxIdNumberNoSession(taxIdNumber, options = {}) {
    const requestPath = `/v2/getUserAndAddressByTaxIdNumberNoSession/${taxIdNumber}`;

    let bearerToken = options.bearerToken;
    let hashAleatorio = options.hashAleatorio;

    // Se não foi fornecido um token, gera um novo
    if (!bearerToken) {
      // Gera hash aleatório se não foi fornecido
      if (!hashAleatorio) {
        hashAleatorio = this.generateRandomHash();
      }

      try {
        bearerToken = await this.generateCpfJwt(taxIdNumber, hashAleatorio);
      } catch (error) {
        console.error("Erro ao gerar JWT:", error);
        throw new Error(
          "Não foi possível gerar token JWT. Verifique se o endpoint /v2/generateCpfJwt está disponível.",
        );
      }
    }

    // Se não foi fornecido hash aleatório e não geramos um token novo, gera um hash agora
    if (!hashAleatorio) {
      hashAleatorio = this.generateRandomHash();
    }

    // Faz a requisição com o Bearer Token e o hash aleatório nos headers
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "X-Frontend-Hash": hashAleatorio,
      "Content-Type": "application/json",
    };

    return axios
      .get(requestPath, { headers })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        // Se erro de autenticação, pode logar ou tratar especificamente
        if (error.response && error.response.status === 401) {
          console.error(
            "Erro de autenticação. Verifique se o token JWT é válido.",
          );
        }
        throw error;
      });
  }

  saveNewEmail(newEmail) {
    localStorage.setItem("newEmail", newEmail);
  }

  getNewEmail() {
    return localStorage.getItem("newEmail");
  }

  saveNewPhone(newPhone) {
    localStorage.setItem("newPhone", newPhone);
  }

  getNewPhone() {
    return localStorage.getItem("newPhone");
  }

  saveLoginTFA(redirect_2fa) {
    localStorage.setItem("redirect_2fa", redirect_2fa);
  }

  getLoginTFA() {
    return localStorage.getItem("redirect_2fa");
  }

  isGrouper(moveMaisId) {
    return axios
      .get(`/v2/agrupadorVPO/getIsClienteVPO/${moveMaisId}`)
      .then((res) => {
        if (res.data && res.data.status && res.data.status.code === 0) {
          const isGrouper = res.data.isGrouper || false;
          this.saveIsGrouper(isGrouper);
          return isGrouper;
        }
        return false;
      })
      .catch((error) => {
        console.error("Erro ao verificar se é grouper:", error);
        return false;
      });
  }

  saveIsGrouper(grouper) {
    localStorage.setItem("grouper", grouper);
  }

  /**
   * Busca os status de notificação disponíveis para o site.
   *
   * @return Promise resolve com array de opções de notificação ou rejeita com erro
   */
  getNotificationStatus() {
    return axios
      .get("/v2/getNotficationStatus/Site")
      .then((res) => {
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }
}

// Singleton  /api/v1
const instance = new AuthService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/auth.js